"use strict";

// Переключалка вкладок.

const $ = window.jQuery;

function autoScroll($elem) {
    // scrolls to elem only if element changed position after some timeout.
    var currentScroll = $(document).scrollTop();
    var top = $elem.offset().top;

    var scrollOnNeed = function () {
        if (top != $elem.offset().top) {
            // element changed position, scroll there
            $("html, body").animate({
                scrollTop: $elem.offset().top + (currentScroll - top),
                duration: 700,
            });
        }
        scrollIntoView($elem[0], $elem.parents(".plaintabs")[0]);
    };
    setTimeout(scrollOnNeed, 100);
}

function scrollIntoView(el, container) { 
    if (!shouldScrollIntoView(el, container)) {
        return;
    }
    let inline = "center";
    if (el.parentNode.nextElementSibling === null) {
        inline = "end";
    }
    el.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: inline,
    }); 
}

function shouldScrollIntoView(el ,container) {
    const gap = 100;
    if (!el || !container) return;
    const rect = el.getBoundingClientRect();
    const container_rect = container.getBoundingClientRect();
    return (
        rect.left < container_rect.left + gap ||
        rect.left + rect.width > container_rect.left + container_rect.width - gap
    ); 
}

var Tabs = function ($el) {
    var self = this;
    self.$el = $el;
    self.$links = $el.find(".plaintabs__header");

    self.onTabClick = function (e) {
        var $link = $(this),
            href = $link.attr("href"),
            changes,
            type = href.split("-")[0];
        if (e && e.pageY) {
            // real event, not trigger
            autoScroll($link);
        }
        self.switchTab(href, $link);

        if (e) e.preventDefault();

        // Sync corresponding tab
        var sync_data = $link.attr("data-sync-with");
        if (!sync_data) return;
        changes = sync_data.split(",");
        for (var i in changes) {
            var ihref = changes[i];
            var content_id = "#" + ihref + href.replace(type, "");
            var $tgt = $("a[href='" + content_id + "']");
            if ($tgt.length) {
                self.switchTab(content_id, $tgt, true);
            }
        }
    };

    self.$links.on("click", "a", self.onTabClick);

    self.scrollToMainTabsList = function () {
        if (!window.location.hash) return;
        var hash_tgt = window.location.hash.split("-");
        var tgt = "";
        if (hash_tgt.length > 1) {
            tgt = hash_tgt[0] + "-tabs";
            if (!$(tgt).length) tgt = window.location.hash;
        }
        var offset = tgt.startsWith("#about") ? -40 : -80;
        var target = $(tgt);
        if (!target.length) {
            target = $("#demo");
            offset = 0;
        }

        if (target.length) {
            $("html, body").animate({
                scrollTop: target.offset().top + offset,
                duration: 700,
            });
        }
    };

    self.activateTab = function (tab_name) {
        var $link = $(".plaintabs__header a[href='" + tab_name + "']");
        var $tab = $(tab_name);
        $(tab_name)
            .addClass("plaintabs__tab--active")
            .show()
            .siblings()
            .removeClass("plaintabs__tab--active")
            .hide();
        $link
            .parent("li")
            .addClass("plaintabs__item--active")
            .siblings()
            .removeClass("plaintabs__item--active");
        return $tab.length;
    };

    self.switchTab = function (href, $link, do_not_replace_href) {
        var self = this;
        self.onTabSwitch(href);
        self.activateTab(href);
        self.focusOnTarget($link.data("focus"));
        if (window.history.replaceState && !do_not_replace_href) {
            window.history.replaceState({}, "", href);
        }
        return true;
    };

    self.focusOnTarget = function (target) {
        var $target = $(target);
        if (!$target) {
            return;
        }

        if (!$target.suggestions) return;
        var sgt = $target.suggestions();
        if (sgt) {
            sgt.disable();
        }
        $target.focus();
        if (sgt) {
            sgt.enable();
        }
    };

    self.onTabSwitch = function () {};
};
Tabs.tabsList = [];
Tabs.create = function ($el) {
    Tabs.tabsList.push(new Tabs($el));
};
Tabs.showActiveTab = function (force_hash) {
    var hash = force_hash || window.location.hash;
    // TODO: distinct synced tabs from independent ones
    // until that, do not mess with synced tabs
    if (!Tabs.tabsList.length) return false;
    var result = false;
    Tabs.tabsList.forEach(function (itabs) {
        var tgt = "#";
        if (Tabs.tabsList.length == 1) {
            tgt = hash;
        } else {
            if (itabs.$el.attr("id")) {
                tgt += itabs.$el.attr("id").split("-")[0] + "-";
            }
            if (hash) {
                tgt += hash.split("-")[1];
            }
        }
        // Detect if we need to scroll to active tab
        var $cont = $(tgt).parents(".plaintabs");
        if (!$cont.length) return;
        if (!$cont.find('a[href="' + tgt + '"]').length) return;
        result = itabs.activateTab(tgt) || result;
    });
    if (result) {
        setTimeout(Tabs.tabsList[0].scrollToMainTabsList, 100);
    }
    return result;
};
Tabs.activateTab = function (tab_name) {
    Tabs.tabsList.forEach(function (itabs) {
        itabs.activateTab(tab_name);
    });
};
Tabs.onTabSwitch = function (fn) {
    Tabs.tabsList.forEach(function (itabs) {
        itabs.onTabSwitch = fn;
    });
};

export default {
    create: Tabs.create,
    showActiveTab: Tabs.showActiveTab,
    activateTab: Tabs.activateTab,
    onTabSwitch: Tabs.onTabSwitch,
};
